import React from 'react'
import './sql-editor.css'

const SqlEditor = ({sql, className}) => {
    return <div className={`${className} sqlEditor`}>
        <textarea defaultValue={sql}></textarea>
    </div>
}

export default SqlEditor